<template><section>
<div class="page">
  <div>
    <h2>Deleting your account</h2>
    <p>You can delete your account from within ToTok. Deleting your account is an irreversible process, which cannot be undone even if you perform it by accident.
    </p>
    <h3>To delete your account</h3>
    <ol>
      <li>Open ToTok.</li>
      <li>Tap<strong> Me > Account > Delete Account</strong>.</li>
      <li>Enter your phone number in full international format and tap SEND VERIFICATION CODE.
      </li>
      <li>Enter the verification code and tap Delete Account.</li>
    </ol>
    <p><strong>Deleting your account will</strong></p>
    <ul>
      <li>Delete your account from ToTok.</li>
      <li>Erase your message history.
      </li>
      <li>Delete you from all of your ToTok groups.</li>
    </ul>


  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
